import { Box, Checkbox, FormControl, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, Select, SelectChangeEvent, TextField, Typography } from "@mui/material";
import { IShortageBoardOptions } from "../../routes/doa-forecast-doa-admin-stats/DoaForecastStatsData";
import { DoaForecastFilterBoardType, SORT_TYPE_DESCRIPTIONS, SortType } from "../../routes/doa-forecast-stats/DoaForecastStatsModels";
import { CheckBoxLabelStyle, CheckBoxStyle, SelectLabelStyle, SelectMenuStyle, SelectStyle, TextFieldStyle, shortageBoardTypeRadioContainerStyle, shortageBoardTypeRadioLabelStyle, shortageBoardTypeRadioStyle, shortageFilterWrapperStyle } from "./styled";

interface IShortageFilterProps<TFilter> {
  filter: TFilter;
  boardOptions: IShortageBoardOptions[];
  onFilterUpdate: (updatedFilter: TFilter) => void;
  checkboxesList?: { label: string; claim: string }[];
}

export const ShortageFilter: React.FC<IShortageFilterProps<any>> = ({
  filter,
  boardOptions,
  onFilterUpdate,
  checkboxesList
}) => {
  const handleBoardTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFilterUpdate({ ...filter, selectedBoardFilter: '', selectedBoardType: event.target.value as DoaForecastFilterBoardType });
  }

  const handleBoardSelectChange = (event: SelectChangeEvent<string>) => {
    onFilterUpdate({ ...filter, selectedBoardFilter: event.target.value as DoaForecastFilterBoardType });
  }

  const handleSortTypeChange = (event: SelectChangeEvent<string>) => {
    onFilterUpdate({ ...filter, selectedSortType: event.target.value as SortType });
  }

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFilterUpdate({ ...filter, selectedNameFilter: event.target.value });
  }

  const handleIncludeCallbackChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFilterUpdate({ ...filter, includeCallback: event.target.checked });
  }

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, claim: string) => {
    onFilterUpdate({ ...filter, [claim]: event.target.checked });
  }

  return (
    <Grid container sx={shortageFilterWrapperStyle}>
      <Grid item xs={12} sm={5}>
        <FormControl fullWidth>
          <RadioGroup
            sx={shortageBoardTypeRadioContainerStyle}
            value={filter.selectedBoardType}
            onChange={handleBoardTypeChange}
          >
            <FormControlLabel sx={shortageBoardTypeRadioLabelStyle} value="union" control={<Radio sx={shortageBoardTypeRadioStyle} />} label="union" />
            <FormControlLabel sx={shortageBoardTypeRadioLabelStyle} value="casual" control={<Radio sx={shortageBoardTypeRadioStyle} />} label="casual" />
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={0} sm={7} />
      <Grid item xs={12} sm={5}>
        <FormControl fullWidth size="small">
          <Typography sx={SelectLabelStyle}>Boards:</Typography>
          <Select
            sx={SelectStyle}
            displayEmpty
            value={filter.selectedBoardFilter}
            onChange={handleBoardSelectChange}
            MenuProps={{ sx: SelectMenuStyle }}
            renderValue={(board) => {
              if (!board) return (
                <Typography sx={{ textTransform: "capitalize" }}>
                  All {filter.selectedBoardType} Boards
                </Typography>
              )
              return boardOptions.filter(b => b.boardCode === board).map(b => b.boardDescription)
            }}
          >
            <MenuItem key={''} value={''}>
              <Typography sx={{ textTransform: "capitalize" }}>
                All {filter.selectedBoardType} Boards
              </Typography>
            </MenuItem>
            {boardOptions?.length > 0 && boardOptions.map(({ boardCode, boardDescription }) => (
              <MenuItem key={boardCode} value={boardCode}>
                {boardDescription}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={5}>
        <FormControl fullWidth size="small">
          <Typography sx={SelectLabelStyle}>Sort By:</Typography>
          <Select
            sx={SelectStyle}
            value={filter.selectedSortType}
            onChange={handleSortTypeChange}
            MenuProps={{ sx: SelectMenuStyle }}
          >
            {SORT_TYPE_DESCRIPTIONS.map(({ code, display }) => (
              <MenuItem key={code} value={code}>
                {display}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={5}>
        <FormControl fullWidth size="small">
          <Typography sx={SelectLabelStyle}>Search By Last Name:</Typography>
          <Box sx={{ margin: "0 24px 16px 24px" }}>
            <TextField
              sx={TextFieldStyle}
              fullWidth
              value={filter.selectedNameFilter}
              onChange={handleNameChange}
            />
          </Box>
        </FormControl>
      </Grid>
      <Grid item xs={0} sm={7} />
      {!checkboxesList && <Grid item xs={12} sm={5}>
        <FormControl fullWidth size="small">
          <Typography sx={CheckBoxLabelStyle} className="bold">
            <Checkbox sx={CheckBoxStyle} checked={filter.includeCallback} onChange={handleIncludeCallbackChange} />
            Include Callbacks (CB)
          </Typography>
        </FormControl>
      </Grid>}
      {
        checkboxesList && checkboxesList.map((cb) => (
          <Grid item xs={12} sm={5} key={cb.claim}>
            <FormControl fullWidth size="small">
              <Typography sx={CheckBoxLabelStyle} className="bold">
                <Checkbox
                  sx={CheckBoxStyle}
                  checked={filter[cb.claim]}
                  onChange={(e) => handleCheckboxChange(e, cb.claim)}
                />
                {cb.label}
              </Typography>
            </FormControl>
          </Grid>
        ))
      }
    </Grid >
  );
}